module.exports = __webpack_public_path__ + "img/providers.e66d5506.svg";